var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAssetRiskIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 35,
    viewBox: "0 0 36 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.8323 2.34766H9.39355V34.0515H25.8323V2.34766Z",
    fill: "#4398D1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.39355 25.2459V34.0525H25.833V6.98047L9.39355 25.2459Z",
    fill: "#3F8FC4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4846 0H11.7422V2.3482H23.4846V0Z",
    fill: "#4398D1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4846 1.17578H11.7422V2.35023H23.4846V1.17578Z",
    fill: "#3F8FC4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0904 5.28516H11.7422V7.63335H14.0904V5.28516Z",
    fill: "#87CED9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7867 5.28516H16.4385V7.63335H18.7867V5.28516Z",
    fill: "#87CED9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4839 5.28516H21.1357V7.63335H23.4839V5.28516Z",
    fill: "#87CED9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0904 9.98242H11.7422V12.3306H14.0904V9.98242Z",
    fill: "#87CED9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7867 9.98242H16.4385V12.3306H18.7867V9.98242Z",
    fill: "#87CED9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4839 9.98242H21.1357V12.3306H23.4839V9.98242Z",
    fill: "#87CED9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0904 14.6777H11.7422V17.0259H14.0904V14.6777Z",
    fill: "#87CED9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7867 14.6777H16.4385V17.0259H18.7867V14.6777Z",
    fill: "#87CED9"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4839 14.6777H21.1357V17.0259H23.4839V14.6777Z",
    fill: "#87CED9"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0904 19.375H11.7422V21.7232H14.0904V19.375Z",
    fill: "#87CED9"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7867 19.375H16.4385V21.7232H18.7867V19.375Z",
    fill: "#87CED9"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4839 19.375H21.1357V21.7232H23.4839V19.375Z",
    fill: "#87CED9"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0904 24.0723H11.7422V26.4205H14.0904V24.0723Z",
    fill: "#87CED9"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7867 24.0723H16.4385V26.4205H18.7867V24.0723Z",
    fill: "#87CED9"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4839 24.0723H21.1357V26.4205H23.4839V24.0723Z",
    fill: "#87CED9"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1356 29.3574H14.0903V34.0545H21.1356V29.3574Z",
    fill: "#87CED9"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2008 29.3555H17.0264V34.0525H18.2008V29.3555Z",
    fill: "#61ACC9"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M5.75408 24.8036C5.89581 24.3743 5.91094 23.914 5.79948 23.4764C5.58689 22.6398 4.92846 21.9896 4.08839 21.7873C2.82657 21.477 1.55305 22.249 1.24275 23.5108C1.19734 23.6938 1.17464 23.8817 1.17464 24.0702C1.17464 24.278 1.20216 24.4844 1.25651 24.6846C1.51934 25.5577 1.42026 26.5002 0.98062 27.299C0.170137 28.7033 0.65106 30.4983 2.0553 31.3088C3.45954 32.1193 5.25526 31.6384 6.06506 30.2341C6.57144 29.3562 6.59001 28.2788 6.11322 27.385C5.64468 26.611 5.51396 25.6774 5.75408 24.8036Z",
    fill: "#88B337"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M4.10999 24.0703H2.93555V34.6382H4.10999V24.0703Z",
    fill: "#79A125"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9349 24.8036C34.0766 24.3743 34.0917 23.914 33.9803 23.4764C33.7677 22.6398 33.1092 21.9896 32.2692 21.7873C31.0073 21.477 29.7331 22.249 29.4235 23.5108C29.3781 23.6938 29.3554 23.8817 29.3554 24.0702C29.3554 24.2779 29.3829 24.4844 29.438 24.6846C29.7015 25.5583 29.6024 26.5016 29.1621 27.3011C28.3509 28.7053 28.8325 30.5004 30.2368 31.3108C31.6403 32.122 33.436 31.6404 34.2465 30.2362C34.7529 29.3583 34.7715 28.2808 34.2947 27.3871C33.8248 26.6131 33.6947 25.6781 33.9349 24.8036Z",
    fill: "#88B337"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2911 24.0703H31.1167V34.6382H32.2911V24.0703Z",
    fill: "#79A125"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2264 33.4648H0V34.6393H35.2264V33.4648Z",
    fill: "#E0D2C1"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssetRiskIcon);
export default __webpack_public_path__ + "static/media/assetRiskIcon.c30fb5df.svg";
export { ForwardRef as ReactComponent };